<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="level of levels"
      :value="level"
      :key="level.code">
        {{ level.name }}
    </option>
  </select>
</template>
<script lang="ts">
import { Level } from '@/store/master/types'
import { RootState } from '@/store/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SelectLevelInput extends Vue {
  @Prop() value!: Level

  created() {
    this.$store.dispatch('fetchMasterLevels')
  }

  private get levels(): Level[] {
    return (this.$store.state as RootState).master.levels
  }

  private get selected(): Level {
    return this.value
  }

  private set selected(level: Level) {
    this.$emit('input', level)
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
